import Vue from "vue";

export default {
  namespaced: true,
  state: {
    designerModelView: {
      prev: 'designer-brands',
      next: 'designer-generations',
      nextName: 'm_id',
      namePage: 'models',
      data: 'models/MODELS',
      active: 'models/MODEL_EDIT',
      plusName: 'Добавить модель',
      secondTitle: true,
      addInfo: {
        name: 'Поколений',
        key: 'generations'
      }
    },
    designerModelViewNew: {
      component: 'EditImg',
      prev: 'designer-models',
      btnText: 'Добавить модель',
      componentData: {
        send: 'models/MODEL_NEW',
        editImg: true,
        imgClass: 'card__img-only card__img--small',
        uploadText: 'Добавить фотографию модели',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Название',
            className: 'col-12',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    designerModelViewEdit: {
      component: 'EditImg',
      prev: 'designer-models',
      btnText: 'Сохранить изменения',
      componentData: {
        data: 'models/MODEL',
        send: 'models/MODEL_EDIT',
        editImg: true,
        imgClass: 'card__img--small',
        uploadText: 'Выбрать новую фотографию',
        inputs: [
          {
            component: 'InputText',
            name: 'name',
            label: 'Название',
            className: 'col-12',
            rules: {
              required: true
            }
          }
        ]
      }
    },
    designerModelViewDisable: {
      component: 'EditImg',
      prev: 'designer-models',
      btnText: 'Отключить модель',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'models/MODEL',
        send: 'models/MODEL_EDIT',
        editImg: false,
        disable: true,
        text: [
          {
            title: 'Эта модель содержит',
            items: [
              {
                key: 'generations',
                word: [
                  'поколений',
                  'поколение',
                  'поколения'
                ]
              }
            ]
          },
          {
            title: 'Все они отключатся автоматически'
          }
        ]
      }
    },
    designerModelViewDelete: {
      component: 'EditImg',
      prev: 'designer-models',
      btnText: 'Удалить модель',
      wrapClass: 'mt50',
      componentClass: 'img-wrap--higher flex-grow-1',
      formClass: 'edit--small',
      componentData: {
        data: 'models/MODEL',
        send: 'models/MODEL_DELETE',
        editImg: false,
        text: [
          {
            title: 'Эта модель содержит',
            items: [
              {
                key: 'generations',
                word: [
                  'поколений',
                  'поколение',
                  'поколения'
                ]
              }
            ]
          },
          {
            title: 'Все они удалятся автоматически'
          }
        ]
      }
    },
    checkModelView: {
      prev: 'check-brands',
      next: 'check-generations',
      namePage: 'models',
      nextName: 'm_id',
      data: 'models/MODELS',
      designer: false,
      titleClass: 'text-no-transform',
      desc: 'Выберите модель, чтобы перейти к определению поколения автомобиля',
      addInfo: {
        name: 'Поколений',
        key: 'generations'
      }
    }
  },
  actions: {
    'MODELS': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}models/${params.brand}`, )
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'MODEL': async (context, params) => {
      return await Vue.http.get(`${process.env.VUE_APP_API_URL}models/${params.brand}/${params.id}`)
        .then(
          res => {
            res.body = res.body[0];
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'MODEL_NEW': async (context, params) => {
      params.file_name = params.photo;
      delete params.photo;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.post(`${process.env.VUE_APP_API_URL}models`, formData)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'MODEL_DELETE': async (context, params) => {
      return await Vue.http.delete(`${process.env.VUE_APP_API_URL}models/${params.brand}/${params.id}`,)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    },
    'MODEL_EDIT': async (context, params) => {
      params.m_id = params.id;
      delete params._id;
      delete params.id;
      let formData = new FormData();
      for (let key in params) {
        formData.append(key, params[key]);
      }
      return await Vue.http.put(`${process.env.VUE_APP_API_URL}models`, formData)
        .then(
          res => {
            return res;
          },
          err => {
            return err;
          }
        )
        .catch(err => console.error(`catch, ${err}`));
    }
  }
}